/* ==========================================================================
 *  Function: Add navingation scroll
 * ======================================================================= */
function fn_parts_navigation_scroll_resize(){
		
	// hide header after scroll on tablet/ mobile
    if ($( '#blog-headline-bar' ).length && $(window).width() < bp_medium) {
		if ($(window).scrollTop() > $( '#blog-content' ).offset().top + $( '.typography h1' ).height()){
            fn_secondary_header_auto_hide();
        } else {
            $('#blog-headline-bar').removeClass( class_active );
        }
    }

    var barHeight = $('#blog-headline-bar').height();
	// fixed detail secondary navigation after scroll on tablet/ mobile
    if ($('#blog-headline-bar').length && $(window).width() < bp_medium){

        var blogContent = $( '#blog-content' ).height() + $( '#blog-content' ).offset().top;

        if ($(window).scrollTop() < blogContent) {
            fn_secondary_navigation_auto_hide(blogContent);
        }
    }


}


var currentTop = 0;
var barHeight = $('#blog-headline-bar').height();
var progressResult = 0;
function fn_secondary_navigation_auto_hide(blogContent) {
    if(currentTop == 0 || currentTop == undefined){
        currentTop = $(window).scrollTop();

    } else {
        progressResult = (100 * (currentTop)) / (blogContent - barHeight);
        if(currentTop < $(window).scrollTop()){
            //Dole
            $('#blog-progress').css( 'width' , progressResult + '%');
            currentTop = $(window).scrollTop();
        } else {
            //Hore
            $('#blog-progress').css( 'width' , progressResult + '%');
            currentTop = $(window).scrollTop();
        }
    }
}



// check for scroll top/bottom and show/hide header
var actualTop = 0

var scrollTop = false;
var offsetTop = 200;
var offsetFromTop = 0;

function fn_secondary_header_auto_hide() {

    if(actualTop == 0 || actualTop == undefined){
        actualTop = $(window).scrollTop();
    } else {
        if(actualTop < $(window).scrollTop()){
            //Dole
            $( '#blog-headline-bar' ).addClass( class_active );
            actualTop = $(window).scrollTop();
            offsetFromTop = 0;
            scrollTop = false;
        } else {
            //Hore
            actualTop = $(window).scrollTop();

            if (!scrollTop){
            	offsetFromTop = actualTop - offsetTop;
            	scrollTop = true;
            } else {
            	if (actualTop < offsetFromTop){
	            	$('#blog-headline-bar').removeClass( class_active );
	            	scrollTop = false;
            	}
            }

        }
        
    }
}
